import { render, staticRenderFns } from "./recommendDrawer.vue?vue&type=template&id=41f42bd1&scoped=true"
import script from "./recommendDrawer.vue?vue&type=script&lang=js"
export * from "./recommendDrawer.vue?vue&type=script&lang=js"
import style0 from "./recommendDrawer.vue?vue&type=style&index=0&id=41f42bd1&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41f42bd1",
  null
  
)

export default component.exports